export default {
    company: state => state.company,
    store: state => state.store,
    group: state => state.group,
    campaigns: state => state.campaigns,
    calendar: state => state.calendar,
};
